<template>
  <v-container justify-center>
    <v-layout justify-center column v-if="!loading" >
        <v-card class="pa-2">
          <v-layout justify-center column v-if="showqrcode">
            <div style="text-align: center" >
              <h2>行人二维码</h2>
            </div>
            <div style="text-align: center" class="mt-2">
              <img :src="signUrl" style="width:200px;height:200px">
            </div>
            <div style="text-align: center">二维码剩余有效时间{{qrcodeEt}}秒</div>
          </v-layout>
          <v-layout justify-center column v-else>
            <div style="text-align: center">行人二维码</div>
            <div style="text-align: center">{{lastRes}}</div>
            <flex xs12  class="mb-1" v-for="p in ledPlus" style="text-align: center">
              {{p}}
            </flex>
            <div style="text-align: center">{{qrcodeNextTime}}秒后可再次生成二维码</div>
          </v-layout>
          <v-layout justify-center>
            <v-btn class="primary" @click="getPassRule">查看通行规则</v-btn>
          </v-layout>
        </v-card>
    </v-layout>
    <v-layout align-center class="pt-4" column style="height: 200px" v-else>
      <v-progress-circular
        :color="'accent'"
        :value="100"
        size="50"
        indeterminate
      ></v-progress-circular>
      <!--<v-btn @click="goTo()">跳转</v-btn>-->
    </v-layout>
  </v-container>
</template>
<script>
import {time} from '../../ladmin/utils/time'
export default {
  data () {
    return {
      loading:false,
      signUrl: '',
      showqrcode: false,
      jsCode: '',
      getStatus: false,
      disabledFlag: false,
      qrcodeSt: '',
      qrcodeEt: '',
      qrcodeNextTime: '',
      lastRes: '',
      ledPlus:[],
      flag:false
    }
  },
  created () {
    let _this = this
    _this.getQrcode()
    setInterval(function () {
      _this.getQrcode()
    }, 3000)
    // this.getQrcode()
  },
  methods: {
    reGet () {
      this.getQrcode()
    },
    getPassRule(){
      this.$router.push({name:'personPassRule_wx'})
    },
    async getQrcode () {
      try {
        if(!this.flag){
          this.loading = true
        }
        let res = await this.$store.dispatch('wx/getQrcode')
        this.loading = false
        this.flag = true
        if (res.data.status === 1) {
          if (res.data.data.type === 1) {
            this.signUrl = '/qrcode' + res.data.data.picPath
            this.showqrcode = true
            this.qrcodeEt = res.data.data.ttl
          }
          else {
            this.showqrcode = false
            this.qrcodeNextTime = res.data.data.nextPicTime
            let lastRes = JSON.parse(res.data.data.lastRes)
            if (lastRes.status + '' === '1') {
              this.lastRes = '扫码成功'
              this.ledPlus = lastRes.data.ledPlus.split('|')
            }
            else {
              this.lastRes = '扫码失败，' + lastRes.msg
              this.ledPlus = []
            }
          }
        }
        else {
          this.$L.alert('error', {message: '获取二维码失败,' + res.data.msg})
          this.getStatus = true
        }
      }catch (e) {
        this.loading = false
      }finally {
        this.loading = false
      }
    },
  }
}
</script>
{
type:2,
lastRes:,
nextPicTime:,
}
{
type:1,
picPath:,
ttl:,
}
